

export interface RATE_AGREEMENT_TABLE {
    RateAgreementStatus:string, BuyerEmail:string, RateAgreementID:number, RevisionNumber:number,
    EffectiveDate:string, ExpiryDate:string , GSDB:string, Name:string, 
    ContactName:string, DescriptionofService:string, 
    Street:string, FuelEscalator:string, AutoExtensionFlag:string, NoticePeriod:number, RenewalTerm:number, ContractDuration:number, 
    InitialContractEffectiveDate:string, MarketTest:string, GISClassification:string, CreatedBy:string, CreatedOn:string, 
    ModifiedOn:string, ModifiedBy:string,Selected?:boolean
}

export const FTL_order = [
    {displayName:"Km Band Min", name:'from' ,order : 1},
    {displayName:"Km Band Max", name:'to' ,order : 2},
    {displayName:"Euro - SINGLE TRIP Inbound km Rate", name:'euro-inbound' ,order : 3},
    {displayName:"Euro - SINGLE TRIP Return km Rate", name:'euro-return' ,order: 4},
    {displayName:"Euro - ROUND TRIP km Rate", name:'euro-round trip' ,order : 5},
    {displayName:"Mega - SINGLE TRIP Inbound km Rate", name:'mega-inbound' ,order : 3},
    {displayName:"Mega - SINGLE TRIP Return km Rate", name:'mega-return' ,order: 4},
    {displayName:"Mega - ROUND TRIP km Rate", name:'mega-round trip' ,order : 5},
    {displayName:"Jumbo - SINGLE TRIP Inbound km Rate", name:'jumbo-inbound' ,order : 3},
    {displayName:"Jumbo - SINGLE TRIP Return km Rate", name:'jumbo-return' ,order: 4},
    {displayName:"Jumbo - ROUND TRIP km Rate", name:'jumbo-round trip' ,order : 5},
    {displayName:"Giga - SINGLE TRIP Inbound km Rate", name:'giga-inbound' ,order : 3},
    {displayName:"Giga - SINGLE TRIP Return km Rate", name:'giga-return' ,order: 4},
    {displayName:"Giga - ROUND TRIP km Rate", name:'giga-round trip' ,order : 5},

]

export const FIXED_FTL_order = [
    {displayName:"Service", name:'service' ,order : 1},
    {displayName:"Euro - SINGLE TRIP Inbound km Rate", name:'euro-inbound' ,order : 2},
    {displayName:"Euro - SINGLE TRIP Return km Rate", name:'euro-return' ,order: 3},
    {displayName:"Euro - ROUND TRIP km Rate", name:'euro-round trip' ,order : 4},
    {displayName:"Mega - SINGLE TRIP Inbound km Rate", name:'mega-inbound' ,order : 2},
    {displayName:"Mega - SINGLE TRIP Return km Rate", name:'mega-return' ,order: 3},
    {displayName:"Mega - ROUND TRIP km Rate", name:'mega-round trip' ,order : 4},
    {displayName:"Jumbo - SINGLE TRIP Inbound km Rate", name:'jumbo-inbound' ,order : 2},
    {displayName:"Jumbo - SINGLE TRIP Return km Rate", name:'jumbo-return' ,order: 3},
    {displayName:"Jumbo - ROUND TRIP km Rate", name:'jumbo-round trip' ,order : 4},
    {displayName:"Giga - SINGLE TRIP Inbound km Rate", name:'giga-inbound' ,order : 2},
    {displayName:"Giga - SINGLE TRIP Return km Rate", name:'giga-return' ,order: 3},
    {displayName:"Giga - ROUND TRIP km Rate", name:'giga-round trip' ,order : 4},

]

export const column_order = [
    {name:"RateAgreementStatus", displayName:'Status' ,order : 1},
    {name:"BuyerEmail", displayName:'Buyer E-Mail' ,order : 2},
    {name:"RateAgreementNumber", displayName:'Rate Agreement Number (ID)' ,order : 3},
    {name:"RevisionNumber", displayName:'Revision Number' ,order: 4},
    {name:"EffectiveDate", displayName:'Effective Date' ,order : 5},
    {name:"ExpiryDate", displayName:'Expiry Date' ,order : 6},
    {name:"GSDB", displayName:'GSDB' ,order : 7},
    {name:"Name", displayName:'Name' ,order : 8},
    {name:"ContactName", displayName:'Contact Name' ,order : 9},
    {name:"DescriptionofService", displayName:'Description Of Service' ,order : 10},
    {name:"FuelEscalator", displayName:"Fuel Escalator Flag", order:11},
    {name:"AutoExtensionFlag", displayName:"Auto Extension Flag", order:12},
    {name:"NoticePeriod", displayName:"Notice Period (Month)", order:13},
    {name:"RenewalTerm", displayName:"Renewal Term (Month)", order:14},
    {name:"ContractDuration", displayName:"Contract Duration", order:15},
    {name:"InitialContractEffectiveDate", displayName:"Initial Contract Effective Date", order:16},
    {name:"Alert", displayName:"Alert", order:17},
    {name:"SpecialTerms", displayName:"Special Terms", order:18},
    {name:"CreatedOn", displayName:'Created (Date/Time)' ,order : 19},
    {name:"CreatedBy", displayName:'Created By' ,order : 20},
    {name:"ModifiedOn", displayName:'Last Modified (Date/Time)' ,order : 21},
    {name:"ModifiedBy", displayName:'Last Modified Name' ,order : 22}
]